import type {ReactElement} from 'react';
import React from 'react';
import {Text, TextSize} from '@Components/text';
import {convertSecondsToMMSSFormat} from '@Utils/date.util';
import ControlledDurationInput from '@Components/controlled-duration-input/controlled-duration-input';
import styles from './base-download-duration.module.scss';
import {ControlledSlider} from '@Components/controlled-slider';

interface BaseDownloadDurationProps {
  duration: number;
  sliderValue: number;
  onSlide: (value: number) => void;
  originalDuration: number;
  onDurationChanged: (value: number) => void;
  min: number;
  max: number;
  marks?: number[];
}

export function BaseDownloadDuration({...props}: BaseDownloadDurationProps): ReactElement {
  return (
    <div className="spacing-p-t-2">
      <div className="flex flex-h-row justify-content-between flex-items-center spacing-m-b-2">
        <Text bold val={window.i18next.t('pmwjs_duration')} size={TextSize.XSMALL} />
        <div className="flex flex-h-row flex-items-center">
          {props.duration !== props.originalDuration ? (
            <Text
              className="content-disabled spacing-m-r-3"
              val={window.i18next.t('pmwjs_original_duration', {duration: convertSecondsToMMSSFormat(props.originalDuration)})}
              size={TextSize.XXSMALL}
            />
          ) : null}
          <ControlledDurationInput
            hideControls
            inputContainerClassName={styles.inputContainer}
            className={styles.duration}
            duration={props.duration}
            onDurationChanged={props.onDurationChanged}
            maxDuration={props.max}
            minDuration={props.min}
            inputClassName={styles.input}
            showSmallInputFont
          />
        </div>
      </div>
      <ControlledSlider marks={props.marks} step={0.1} min={props.min} max={props.max} value={props.sliderValue} onSlide={props.onSlide} className={styles.slider} />
    </div>
  );
}
